import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TICKET_STATUS_LABELS } from "@jetbot/common";
const STATUS_STYLES = {
    new: "bg-blue-500/15 text-blue-400 border-blue-500/25",
    investigating: "bg-yellow-500/15 text-yellow-400 border-yellow-500/25",
    awaiting_reporter: "bg-orange-500/15 text-orange-400 border-orange-500/25",
    duplicate: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25",
    issue_created: "bg-violet-500/15 text-violet-400 border-violet-500/25",
    fixing: "bg-indigo-500/15 text-indigo-400 border-indigo-500/25",
    fix_failed: "bg-red-500/15 text-red-400 border-red-500/25",
    staging_ready: "bg-cyan-500/15 text-cyan-400 border-cyan-500/25",
    deploying: "bg-blue-500/15 text-blue-400 border-blue-500/25 animate-pulse",
    testing: "bg-teal-500/15 text-teal-400 border-teal-500/25",
    approved: "bg-green-500/15 text-green-400 border-green-500/25",
    merged: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
    closed: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25",
    wont_fix: "bg-zinc-500/15 text-zinc-400 border-zinc-500/25",
};
export function TicketStatusBadge({ status, className }) {
    return (_jsx(Badge, { variant: "outline", className: cn(STATUS_STYLES[status], className), children: TICKET_STATUS_LABELS[status] }));
}
